<template>
    <div class="ibox">
        <div :class="[{'ibox-title': !isPdfExport, 'ibox-grey':!isPdfExport}]">
            <h4 v-if="analyzeType == 'sell'">{{ __('analyze_choosen_sell_positions') }}</h4>
            <h4 v-else>{{ __('analyze_choosen_buy_positions') }}</h4>
            <div class="ibox-tools">
                <a href="#" v-if="!isPdfExport" @click.prevent="toggleVisible()"><i class="fas fa-cogs"></i></a>
                <button-open-help-modal v-if="showHelp == 1" :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-007' : 'ASB-007'"/>
            </div>
        </div>
        <div class="ibox-content">
            <div class="table-container" v-if="statusCriterias">
                <!-- bez table-fixed: szerokosci kolumn wg tresci (max 13 kolumn, limit w SettingsModal);
                     tryb PDF ustawia table-layout: fixed w ShowAnalyzePattern.vue -->
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th :class="['w-40', 'text-truncate' , 'text-wrap' , 'sticky-header' ,'th-first', {'th-export-pdf':isPdfExport}]"></th>
                        <th v-for="(column, index)  in columnsSelected" :class="[{'text-right':textRight(column), 'text-left':!textRight(column)}, 'text-truncate', 'text-wrap', 'sticky-header', {'th-last': index === columnsSelected.length - 1}, {'th-export-pdf':isPdfExport}]">
                            {{ getTrans(column) }}
                        </th>
                        <!-- Dodaj więcej nagłówków, jeśli to konieczne -->
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(key, index) in Object.keys(groupedAndSortedDocumentItems)">

                        <tr>
                            <td :class="[{'ibox-title':!isPdfExport, 'group-name-pdf':isPdfExport } ,'text-bold']" :colspan="columnsSelected.length + 1"
                                @click="toggleGroup(key)"><i
                                :class="isGroupOpen(key) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
                                style="margin-right: 5px;" :title="isGroupOpen(key) ? __('collapse') : __('expand')"
                            />{{ getGroupDescription(groupedAndSortedDocumentItems[key][0]) }}
                            </td>
                        </tr>
                        <tr :class="['row-even', 'text-bold', {'pdf-export-row': isPdfExport} ]">
                            <td class="w-40">{{ __("sum") }}</td>
                            <td v-for="selectedColumn in columnsSelected" class="text-right white-space-no-wrap" :class="{'small-font':groupByCurrency.includes(selectedColumn)}" v-html="sum(selectedColumn, groupedAndSortedDocumentItems[key])">
<!--                                <span class="white-space-no-wrap text-right" v-html="sum(selectedColumn, groupedAndSortedDocumentItems[key])"></span>-->
                            </td>
                        </tr>
                        <tr v-for="item in groupedAndSortedDocumentItems[key]" :key="item.id" :class="{'pdf-export-row': isPdfExport}"
                            v-if="isGroupOpen(key)">
                            <td class="w-40"></td>
                            <!-- kolumny skalowalne (ANALYZE_COLUMN_TEXT_RULES) zawijaja sie do miejsca, ktore zostaje
                                 po kolumnach nieskalowalnych - te nie zawijaja sie wcale. PDF (table-layout: fixed)
                                 zostaje przy zawijaniu wszystkiego poza kwotami, inaczej tekst wychodzilby poza kolumne -->
                            <td v-for="column in columnsSelected" :key="column" :class="cellClass(column)">
                                <wrapped-text v-if="!isPdfExport && textRule(column) && textRule(column).max" :text="getValue(column, item)"
                                              :line_max="textRule(column).max" :max_length="textRule(column).max"/>
                                <template v-else>{{ getValue(column, item) }}</template>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <p>{{ __("criterias_groups_not_defined") }}</p>
            </div>
        </div>

    </div>
</template>
<style scoped>
.pdf-export-mode {
    background-color: #dddddd;
    text-align: left;
}
.pdf-export-row td {
    border-bottom: 1px solid #9e9e9e !important; /* ciemniejsza linia */
}
table {
    border-collapse: collapse !important;
}
.group-name-pdf{
    background-color: #e0e0e0;
    color: black;
}
.th-export-pdf {
    background-color: #bbbbbb;
    color: black;
    padding: 6px;
    border: 1px solid white !important;
}
</style>
<script>
import {getTransForAnalyze, ANALYZE_COLUMN_TEXT_RULES} from "./mixin";
import {Money} from '../../services/Money';

export default {
    name: "GroupedAndSortedDocuments",
    mixins: [getTransForAnalyze],
    data: function () {
        return {
            money: new Money(),
            openGroups: Object.keys(this.groupedAndSortedDocumentItems),
            groupByCurrency: ['item_net_amount', 'item_gross_amount', 'item_vat_amount', 'vat_refund_amount', 'net_and_vat_cost', 'item_margin', 'item_margin_vat_amount'],
            groupByValue: ['net_in_base_currency'],
        }
    },
    props: {
        groupedAndSortedDocumentItems: {
            type: Object
        },
        showHelp:{
            type: Number,
            default:1
        },
        analyzeType: {
            type: String
        },
        analyzeLevel: {
            type: Object
        },
        showAnalyzeGroups: {
            type: Boolean,
        },
        columnsSelected: {
            type: Array
        },
        analyzeCriteriaStatus: {
            type: Object
        },
        fromSavedPattern:{
            type:Boolean,
            default:false
        },
        isPdfExport:{
            type: Boolean,
            default:false
        }
    },
    methods: {
        toggleVisible(){
            this.$emit('showModal');
        },
        sum(column, group) {
            if (this.groupByValue.includes(column)) {
                const sum = group.reduce((total, obj) => total + parseFloat(obj[column]), 0);
                return this.money.localize(sum);
            }
            if (this.groupByCurrency.includes(column)) {
                const grouped = {};
                group.forEach(item => {
                    const currency = item.document_currency;
                    if (!grouped[currency]) {
                        grouped[currency] = 0; // Początkowa suma dla danej waluty
                    }
                    grouped[currency] += parseFloat(item[column]);
                });
                const result = Object.keys(grouped)
                    .map(currency => `${this.money.localize(isNaN(grouped[currency])  ? 0 :  grouped[currency])} ${currency} `)
                    .join('<br/> ');

                return result;
            }
            return '';
        },
        toggleGroup(key) {
            if (this.isGroupOpen(key)) {
                // Jeśli grupa jest otwarta, zamknij ją
                const index = this.openGroups.indexOf(key);
                if (index > -1) {
                    this.openGroups.splice(index, 1);
                }
            } else {
                // Jeśli grupa jest zamknięta, otwórz ją
                this.openGroups.push(key);
            }
        },
        isGroupOpen(key) {
            return this.openGroups.includes(key);
        },
        getGroupDescription(item) {
            let levels = [];
            if (this.analyzeLevel['analyze_level_1']) {
                if (this.analyzeLevel['analyze_level_1'] == 'contractor' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_1']]] == 'REST') {
                    levels.push("rest_contractors")
                } else if (this.analyzeLevel['analyze_level_1'] == 'item' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_1']]] == 'REST') {
                    levels.push("rest_items")
                }else if (this.analyzeLevel['analyze_level_1'] == 'currency' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_1']]] == 'REST') {
                    levels.push("rest_currencies")
                }
                else {
                    levels.push(this.getDescriptionMap[this.analyzeLevel['analyze_level_1']])
                }

            }
            if (this.analyzeLevel['analyze_level_2']) {
                if (this.analyzeLevel['analyze_level_2'] == 'contractor' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_2']]] == 'REST') {
                    levels.push("rest_contractors")
                } else if (this.analyzeLevel['analyze_level_2'] == 'item' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_2']]] == 'REST') {
                    levels.push("rest_items")
                }else if (this.analyzeLevel['analyze_level_2'] == 'currency' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_2']]] == 'REST') {
                    levels.push("rest_currencies")
                }
                else {
                    levels.push(this.getDescriptionMap[this.analyzeLevel['analyze_level_2']])
                }
            }
            if (this.analyzeLevel['analyze_level_3']) {
                if (this.analyzeLevel['analyze_level_3'] == 'contractor' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_3']]] == 'REST') {
                    levels.push("rest_contractors")
                } else if (this.analyzeLevel['analyze_level_3'] == 'item' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_3']]] == 'REST') {
                    levels.push("rest_items")
                } else if (this.analyzeLevel['analyze_level_3'] == 'currency' && item[this.getDescriptionMap[this.analyzeLevel['analyze_level_3']]] == 'REST') {
                    levels.push("rest_currencies")
                }
                else {
                    levels.push(this.getDescriptionMap[this.analyzeLevel['analyze_level_3']])
                }
            }
            let result = [];
            for (let i = 0; i < levels.length; i++) {
                if (levels[i] == 'rest_items' || levels[i] == 'rest_contractors' || levels[i] == 'rest_currencies') {
                    result.push(this.__(levels[i]));
                } else {
                    result.push(item[levels[i]]);
                }

            }
            let filteredResult = result.filter(function (element) {
                return element !== undefined;
            });
            if(filteredResult.length == 1){
                return filteredResult[0];
            }
            return filteredResult.join(' / ');

        },
        getTrans(column) {
            return this.getTransColumn(column)
        },
        isMoney(column) {
            return this.isMoneyFormat(column)
        },
        textRule(column) {
            return ANALYZE_COLUMN_TEXT_RULES[column] || null;
        },
        cellClass(column) {
            const wraps = this.isPdfExport ? !this.isMoney(column) : this.textRule(column) !== null;
            return {
                'wrap-text-inside-td': wraps,
                'white-space-no-wrap': !wraps,
                'text-right': this.isMoney(column) || column == 'real_payment_in_days' || column == 'payment_term_in_days',
            };
        },
        textRight(column){
           return  ["price_before_discount"
            ,"discount"
            ,"item_vat_rate"
            ,"item_vat_amount"
            ,"item_margin"
            ,"item_margin_vat_amount"
            ,"payment_term_in_days"
            ,"real_payment_in_days"
            ,"item_unit_price"
            ,"item_quantity"
            ,"item_net_amount"
            ,"item_gross_amount"
            ,"net_in_base_currency",
            'excise_tax_amount'].includes(column);

        },
        getValue(column, document) {
            if (column.includes('_id')) {
                column = column.replace('_id', '_display');
            }
            if (this.isMoney(column)) {
                if(document[column] !== '' && document[column] != '-'){
                    return this.money.localize(document[column])
                }
                return '-';
            } else {
                return document[column];
            }
        }
    },
    computed: {
        getDescriptionMap: function () {
            const orderMapping = {
                contractor: "contractor_item_name",
                item: "order_item_name",
                currency: "currency_item_name",
                date: "date_item_name",
            };
            return orderMapping;
        },
        statusCriterias: function () {
            let allNull = true;

            for (let key in this.analyzeLevel) {
                if (key != 'date_segregation' && key != 'currency_segregation' && this.analyzeLevel[key] !== null && this.analyzeLevel[key] != 0) {
                    allNull = false;
                    break;
                }
            }
            if (allNull) {
                return false;
            }
            let allStatusReady = true;
            for (let key in this.analyzeLevel) {
                if (this.analyzeLevel[key] !== null  && this.analyzeLevel[key] != 0 && key != 'date_segregation' && key != 'currency_segregation' && this.analyzeCriteriaStatus[this.analyzeLevel[key]] != 'ready') {
                    allStatusReady = false;
                    break;
                }
            }
            if (!allStatusReady) {
                return false;
            }
            this.openGroups = Object.keys(this.groupedAndSortedDocumentItems)
            return true;
        }
    }
}
</script>
<style scoped>
.sticky-header {
    position: -webkit-sticky;
    position: sticky;
    top: 55px;
    z-index: 2; /* Opcjonalne: Jeśli masz inne elementy z wyższym z-index, aby nagłówki były na wierzchu */
}
.small-font {
    font-size: smaller;
}
</style>
